export default __webpack_public_path__ + "static/media/icon-doctor.d0d465ff.svg";